{
  "version": 1,
  "asset_id": "985de7cf-eab7-42b9-9357-f5f6a199ad9e",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/985de7cf-eab7-42b9-9357-f5f6a199ad9e/clip-img_0012.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/985de7cf-eab7-42b9-9357-f5f6a199ad9e/clip-img_0012.mp4",
  "original_filename": "clip-img_0012.mp4",
  "size": 500161,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:21Z"
}
